export function getTTName(tt_id, tts) {
    let name;
    switch (tt_id) {
        case "TT_ID0":
            switch (tts) {
                case "tts1":
                    name = "Klima";
                    break;
                case "tts2":
                    name = "Uzun Far";
                    break;
                case "tts3":
                    name = "Kısa Far";
                    break;
                case "tts4":
                    name = "Dönüş Sinyalleri";
                    break;
                case "tts5":
                    name = "Tehlike Uyarısı";
                    break;
                case "tts6":
                    name = "Engelliler İçin Anlam";
                    break;
                case "tts7":
                    name = "El Freni";
                    break;
                case "tts8":
                    name = "Fren Arızası";
                    break;
                case "tts9":
                    name = "Tavan Kapağı";
                    break;
                case "tts10":
                    name = "Yakıt Seviyesi";
                    break;
                case "tts11":
                    name = "Motor Suyu Soğutma";
                    break;
                case "tts12":
                    name = "Akıllı Şarj Durumu";
                    break;
                case "tts13":
                    name = "Motor Yağı";
                    break;
                case "tts14":
                    name = "Pozisyon Lambaları";
                    break;
                case "tts15":
                    name = "Ön Sis Lambaları";
                    break;
            }
            break;
        case "TT_ID1":
            switch (tts) {
                case "tts1":
                    name = "Arka Sis Lambaları";
                    break;
                case "tts2":
                    name = "Park Isıtma";
                    break;
                case "tts3":
                    name = "Motor / MI Göstergesi";
                    break;
                case "tts4":
                    name = "Servis & Bakım";
                    break;
                case "tts5":
                    name = "Şanzıman Sıvısı";
                    break;
                case "tts6":
                    name = "Şanzıman Hatası";
                    break;
                case "tts7":
                    name = "ABS Arızası";
                    break;
                case "tts8":
                    name = "Aşınmış Fren Arızası";
                    break;
                case "tts9":
                    name = "Ön Cam Yıkama Sıvısı";
                    break;
                case "tts10":
                    name = "Lastik Arızası";
                    break;
                case "tts11":
                    name = "Arıza / Genel Arıza";
                    break;
                case "tts12":
                    name = "Motor Yağı Sıcaklık Göstergesi";
                    break;
                case "tts13":
                    name = "Motor Yağı Seviyesi";
                    break;
                case "tts14":
                    name = "Motor Soğutma Suyu";
                    break;
                case "tts15":
                    name = "Direksiyon Sıvısı Seviyesi";
                    break;
            }
            break;
        case "TT_ID2":
            switch (tts) {
                case "tts1":
                    name = "Direksiyon Arızası";
                    break;
                case "tts2":
                    name = "Yükseklik Kontrolü";
                    break;
                case "tts3":
                    name = "Retarder";
                    break;
                case "tts4":
                    name = "Motor Emisyon Sistemi";
                    break;
                case "tts5":
                    name = "ESC Göstergesi";
                    break;
                case "tts6":
                    name = "Fren Lambası";
                    break;
                case "tts7":
                    name = "Körüklü Araç";
                    break;
                case "tts8":
                    name = "Durma Talebi";
                    break;
                case "tts9":
                    name = "Çocuk Arabası İsteği";
                    break;
                case "tts10":
                    name = "Otobüs Durağı Freni";
                    break;
                case "tts11":
                    name = "Adblue Seviyesi";
                    break;
                case "tts12":
                    name = "Kaldırma";
                    break;
                case "tts13":
                    name = "Düşürme";
                    break;
                case "tts14":
                    name = "Alçaltma";
                    break;
                case "tts15":
                    name = "Motor Bölmesi Sıcaklığı";
                    break;
            }
            break;
        case "TT_ID3":
            switch (tts) {
                case "tts1":
                    name = "Yardımcı Hava Basıncı";
                    break;
                case "tts2":
                    name = "Hava Filtresi";
                    break;
                case "tts3":
                    name = "Yakıt Filtresi Fark Basıncı";
                    break;
                case "tts4":
                    name = "Emniyet Kemeri";
                    break;
                case "tts5":
                    name = "EBS";
                    break;
                case "tts6":
                    name = "Şeritten Ayrılma Göstergesi";
                    break;
                case "tts7":
                    name = "Gelişmiş Acil Durum Fren Sis.";
                    break;
                case "tts8":
                    name = "ACC";
                    break;
                case "tts9":
                    name = "Römork Bağlandı";
                    break;
                case "tts10":
                    name = "ABS Trailer 1-2";
                    break;
                case "tts11":
                    name = "Airbag";
                    break;
                case "tts12":
                    name = "EBS Trailer 1-2";
                    break;
                case "tts13":
                    name = "Takograf Göstergesi";
                    break;
                case "tts14":
                    name = "ESC Göstergesi Kapalı";
                    break;
                case "tts15":
                    name = "Şeritten Ayrılma Gös. Kapalı";
                    break;
            }
            break;
        case "TT_ID4":
            switch (tts) {
                case "tts1":
                    name = "Motor Emisyon Filtresi";
                    break;
                case "tts2":
                    name = "Elektrik Motoru Arızaları";
                    break;
                case "tts3":
                    name = "Adblue Sıcaklığı";
                    break;
                case "tts4":
                    name = "Multipleks Sistemi";
                    break;
            }
            break;
    }

    return name;
}